import { Pipe, PipeTransform } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';

@Pipe({
  name: 'optionsLabel',
})
export class OptionsLabelPipe implements PipeTransform {
  transform(key: string | string[], options?: AnyType[]): string {
    if (!key) {
      return key;
    }

    if (Array.isArray(key)) {
      return key.map((k) => this.getLabel(k, options)).join(', ');
    }

    return this.getLabel(key, options);
  }

  private getLabel(key: string, options?: AnyType[]): string {
    if (options) {
      const option = options.find((o) => o._id === key || o.id === key);
      if (option) {
        return option.name;
      }
    }
    return key;
  }
}
